import React, { useEffect, useState } from 'react';
import Headers from '../components/Header3';
import { Link, useNavigate } from 'react-router-dom';
import { Row, Col, Form } from 'react-bootstrap';
import Hero from '../Images/hero.jpg';
import { Zoom, Fade } from 'react-reveal';
import {TextField, Button} from '@mui/material';
import { IoChevronBackCircleOutline } from 'react-icons/io5';
import { toast, ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Tcmodel from '../components/Tcmodel'
import { Domain } from '@mui/icons-material';

const countryOptions = [
  // { label: 'United Kingdom', value: '1' },
  { label: 'India', value: '2' },
  // { label: 'Canada', value: '3' },
];

const Finalform = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  const [region, setRegion] = useState('');
  const [myCountry, setCountry] = useState(null);
  const [state, setState] = useState([]);
  const [brand, setBrand] = useState('');
  const [websiteURL, setWebsiteURL] = useState('');
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [stateOptions, setStateOptions] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  // const country = sessionStorage.getItem('selectedSubService');

  useEffect(() => {
    const storedCountry = sessionStorage.getItem('selectedSubService');
    if (storedCountry) {
      const foundCountry = countryOptions.find((c) => c.label === storedCountry);
      if (foundCountry) {
        setCountry(foundCountry);
        fetchStates(foundCountry.value);
      }
    }
  }, []);


  const fetchStates = async (countryId) => {
    try {
      const response = await fetch(`https://verse.blaccdot.com/ldsstagingindia/masters/location/country-based-province/${countryId}`)
      const data = await response.json();
  
      if (data?.data?.locationmaster) {
        const formattedStates = data.data.locationmaster.map((state) => ({
          label: state.locationName,  
          value: state.provinceId,   
        }));
        setStateOptions(formattedStates);
      }
    } catch (error) {
      console.error('Error fetching states:', error);
      setStateOptions([]); 
    }
  };

  const handleSubmit = async () => {

    sessionStorage.setItem('name', name);
    sessionStorage.setItem('email', email);
    sessionStorage.setItem('number', number);
    sessionStorage.setItem('country', myCountry?.label || '');
    sessionStorage.setItem('state', JSON.stringify(state?.map(item => parseInt(item.value, 10)) || []));
    sessionStorage.setItem('brand', brand);
    sessionStorage.setItem('websiteURL', websiteURL);
    sessionStorage.setItem('conuntyid', myCountry?.value || '');

    const serviceid = parseInt(sessionStorage.getItem('serviceid'), 10)
    
    if (!validateForm()) {
      return; 
    }

    setLoading(true);

    const payload = {
      name,
      email,
      number,
      country: myCountry?.label || '',
      state: state.map((item) => parseInt(item.value, 10)) || [],
      city: region,
      brand_name: brand,
      url: websiteURL,
      category:serviceid
    };

    try {
      const selectedService = sessionStorage.getItem('selectedService')

      const response = await fetch('https://euctostaging.com/ldsstagingindia/api/businessinitialform', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
    
        // if(result.id){
        //   sessionStorage.setItem('finalFormID', result.id);
        //   window.location.replace('/subscription');
        // }


      if (result.id) {
        sessionStorage.setItem('finalFormID', result.id);

        if (result.country === 'India' && selectedService === 'Real Estate') {
          window.location.replace('/subscription');
        } else {
          window.location.replace('/appointment');
        }
     }

    } catch (error) {
      console.error('Error while submitting form:', error);
    } finally {
      setLoading(false);
    }
  };
  const validateForm = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const contactRegex = /^\d{10}$/;

    if (!name.trim()) {
      errors.fullName = 'Full Name is required';
    }

    if (!email.trim()) {
      errors.email = 'Email is required';
    } else if (!emailRegex.test(email)) {
      errors.email = 'Invalid email format';
    }

    if (!number.trim()) {
      errors.contactNo = 'Contact Number is required';
    } else if (!contactRegex.test(number)) {
      errors.contactNo = 'Kindly enter correct number';
    }

    if (!agreeToTerms) {
      errors.agreeToTerms = 'You must agree to the Terms & Conditions';
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle Change Function
  const handleChange = (e) => {
    const { name, value } = e.target;
    const newErrors = { ...errors };

    if (name === 'fullName') {
      setName(value);
      delete newErrors['fullName'];
    } else if (name === 'email') {
      setEmail(value);
      delete newErrors['email'];
    } else if (name === 'contactNo') {
      setNumber(value);
      delete newErrors['contactNo'];
    }

    setErrors(newErrors);
  };

  const handleCheckboxChange = (e) => {
    setAgreeToTerms(e.target.checked);
    const newErrors = { ...errors };
    delete newErrors['agreeToTerms'];
    setErrors(newErrors);
  };
  
  const domainName = sessionStorage.getItem('selectedService')

  
  
  return (
  <div>
      <Headers />
      <ToastContainer />
      <div style={{backgroundColor:'#E6EDF3',height: '85vh', width: '100vw', margin: '0',padding: '0'}}>
      <div className="container py-3" >
        <div className="formBoxsh">
          <div className="container">
            <Row>
              <Col xs={5} style={{ padding: '0px', flex: '0 0 auto', width: '41.66666667%' }} className="FormImages">
                <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                  <img alt='imageRac' src={Hero} style={{ width: '95%', borderRadius: '10px 10px 10px 10px', marginTop: '10px', height: '445px' }} />
                </div>
              </Col>
              <Col xs={12} md={7} style={{ padding: '0px', position: 'relative' }}>
                <div className='mainTopic'
                  style={{
                    width: '55%',
                    height: '20%',
                    borderRadius: '0px 10px 10px 0px',
                    border: '7px solid #00A0E3',
                    marginTop: '10px',
                    fontWeight: '600',
                    backgroundColor: '#00A0E3',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                  <Zoom right>
                    <h5  style={{ color: '#ffff', fontFamily: 'Lato, sans-serif', margin: '0px', fontWeight: '600' }}>One step to get quality leads</h5>
                  </Zoom>
                </div>
                <Link to="/"><IoChevronBackCircleOutline className='backButton' size={40} style={{ position: 'absolute', right: '5%', top: '2%', color: 'red' }} /></Link>
                
                  <div className="calenderHeight" style={{ marginTop: '25px', display: 'flex', justifyContent: 'center' }}>
                    <div className="container">
                      {/* Personal Details */}
                      <Row>
                        <Col xs={12} md={4}>
                          <Form.Group>
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="fullName"
                              value={name}
                              onChange={handleChange}
                              isInvalid={!!errors.fullName} />
                            <Form.Control.Feedback type="invalid">{errors.fullName}</Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={4}>
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            onChange={handleChange}
                            isInvalid={!!errors.email}
                          />
                          <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                        </Col>
                        <Col xs={12} md={4}>
                          <Form.Label>Contact Number</Form.Label>
                          <Form.Control
                            type="type"
                            name="contactNo"
                            value={number}
                            onChange={handleChange}
                            isInvalid={!!errors.contactNo} />
                          <Form.Control.Feedback type="invalid">{errors.contactNo}</Form.Control.Feedback>
                        </Col>
                      </Row>

                      {/* Region area */}
                    <Row className="mt-4">
                        <Col xs={12} md={6} className='finalform-country-space'>
                        <Select
                              options={countryOptions}
                              value={myCountry}
                              onChange={(selectedOption) => {
                                setCountry(selectedOption);
                                setState([]); // Reset selected state(s)
                                fetchStates(selectedOption.value); // Fetch states for selected country
                              }}
                              placeholder="--Select country--"
                            />
                        </Col>

                        {/* State Dropdown */}
                        <Col xs={12} md={6}>
                        <Select
                          isMulti
                          options={stateOptions} // Dynamic options (pass your fetched data here)
                          value={state}
                          onChange={setState}
                          isDisabled={!myCountry}
                          placeholder="--Select State--"
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          components={{
                            Option: (props) => {
                              const { data, isSelected, innerRef, innerProps } = props;
                              return (
                                <div ref={innerRef} {...innerProps} style={{ display: "flex", alignItems: "center", padding: "5px" }}>
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={() => {}} // Required to prevent React warnings
                                    style={{ marginRight: "8px" }}
                                  />
                                  {data.label}
                                </div>
                              );
                            },
                          }}
                        />

                        </Col>
                      </Row>

                      {/* Area Name */}
                      <Row className="mt-4">
                        <Col xs={12} md={4}>
                          <TextField  name="brandName" label="Brand Name" variant="outlined" style={{ width: '100%',  }} className='inputBoxes'  value={brand}  onChange={(e)=> setBrand(e.target.value)} />
                        </Col>
                        <Col xs={12} md={4}>
                          <TextField name="websiteURL" label="Website url" variant="outlined" style={{ width: '100%',}} className='inputBoxes'  value={websiteURL}  onChange={(e)=> setWebsiteURL(e.target.value)}  />
                        </Col>
                        <Col xs={12} md={4}>
                          <TextField label="Selected Domain" variant="outlined" style={{ width: '100%',}} className='inputBoxes'  value={domainName} disabled />
                        </Col>
                      </Row>
              <div className="d-flex align-items-center mt-4">
                <FormControlLabel
                  control={<Checkbox color="primary" checked={agreeToTerms} onChange={handleCheckboxChange} />}
                  label={
                    <p style={{ fontSize: "14px", color: "#555", marginBottom:'0px' }}>
                      I agree to the <span  onClick={() => setModalShow(true)} style={{ color: "#007bff", textDecoration: "none", fontWeight: "500" }}>Terms & Conditions</span>
                    </p>
                  }
                />
                {errors.agreeToTerms && <span style={{ color: 'red', marginLeft: '10px' }}>{errors.agreeToTerms}</span>}
              </div>
        
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '15px 0px 15px 0px' }}>
                <Button variant="contained" onClick={handleSubmit} disabled={loading}>
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    <>PROCESS</>
                  )}
                </Button>
              </div>
                    </div>
                  </div> 
            
              </Col>
            </Row>
          </div>
        </div>
      </div>
      </div>
      <Tcmodel show={modalShow} onHide={() => setModalShow(false)}/>
    </div>
  );
};

export default Finalform;



// import React, { useEffect, useState } from 'react';
// import Headers from '../components/Header';
// import { Link, useNavigate } from 'react-router-dom';
// import { Row, Col, Form } from 'react-bootstrap';
// import Hero from '../Images/hero.jpg';
// import { Zoom, Fade } from 'react-reveal';
// import TextField from '@mui/material/TextField';
// import { IoChevronBackCircleOutline } from 'react-icons/io5';
// import { toast, ToastContainer } from 'react-toastify'; 
// import 'react-toastify/dist/ReactToastify.css';
// import Select from 'react-select'
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
// import Tcmodel from '../components/Tcmodel'

// const countryOptions = [
//   { label: 'United Kingdom', value: '1' },
//   { label: 'India', value: '2' },
//   { label: 'Canada', value: '3' },
// ];

// const Finalform = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [number, setNumber] = useState('');
//   const [region, setRegion] = useState('');
//   const [myCountry, setCountry] = useState(null);
//   const [state, setState] = useState([]);
//   const [brand, setBrand] = useState('');
//   const [websiteURL, setWebsiteURL] = useState('');
//   const [agreeToTerms, setAgreeToTerms] = useState(false);
//   const [stateOptions, setStateOptions] = useState([]);
//   const [modalShow, setModalShow] = React.useState(false);

//   // const handleClose = () => setShow(false);
//   // const handleShow = () => setShow(true);

//   // const country = sessionStorage.getItem('selectedSubService');

//   useEffect(() => {
//     const storedCountry = sessionStorage.getItem('selectedSubService');
//     if (storedCountry) {
//       const foundCountry = countryOptions.find((c) => c.label === storedCountry);
//       if (foundCountry) {
//         setCountry(foundCountry);
//         fetchStates(foundCountry.value);
//       }
//     }
//   }, []);



//   const fetchStates = async (countryId) => {
//     try {
//       const response = await fetch(`https://verse.blaccdot.com/ldsstagingindia/masters/location/country-based-province/${countryId}`)
//       const data = await response.json();
  
//       if (data?.data?.locationmaster) {
//         const formattedStates = data.data.locationmaster.map((state) => ({
//           label: state.locationName,  
//           value: state.provinceId,   
//         }));
//         setStateOptions(formattedStates);
//       }
//     } catch (error) {
//       console.error('Error fetching states:', error);
//       setStateOptions([]); 
//     }
//   };

//   const handleSubmit = async () => {

//     sessionStorage.setItem('name', name);
//     sessionStorage.setItem('email', email);
//     sessionStorage.setItem('number', number);
//     sessionStorage.setItem('country', myCountry?.label || '');
//     sessionStorage.setItem('state', JSON.stringify(state?.map(item => parseInt(item.value, 10)) || []));
//     sessionStorage.setItem('brand', brand);
//     sessionStorage.setItem('websiteURL', websiteURL);
//     sessionStorage.setItem('conuntyid', myCountry?.value || '');
  

//     if (!validateForm()) {
//       return; 
//     }

//     setLoading(true);

//     const payload = {
//       name,
//       email,
//       number,
//       country: myCountry?.label || '',
//       state: state.map((item) => parseInt(item.value, 10)) || [],
//       city: region,
//       brand_name: brand,
//       url: websiteURL,
//     };

//     try {
//       const response = await fetch('https://euctostaging.com/ldsstagingindia/api/businessinitialform', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(payload),
//       });

//       const result = await response.json();
//       if (result.id) {
//         sessionStorage.setItem('finalFormID', result.id);
//         // toast.success('Submitted Successfully!', {
//         //   position: 'top-right',
//         //   autoClose: 2000,
//         //   hideProgressBar: false,
//         //   closeOnClick: true,
//         //   pauseOnHover: true,
//         //   draggable: true,
//         //   theme: 'dark',
//         //   transition: Bounce,
//         // });
//         setTimeout(() => {
//           window.location.replace('/subscription');
//         }, 1000);
//       }
//     } catch (error) {
//       console.error('Error while submitting form:', error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const validateForm = () => {
//     const errors = {};
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const contactRegex = /^\d{10}$/;

//     if (!name.trim()) {
//       errors.fullName = 'Full Name is required';
//     }

//     if (!email.trim()) {
//       errors.email = 'Email is required';
//     } else if (!emailRegex.test(email)) {
//       errors.email = 'Invalid email format';
//     }

//     if (!number.trim()) {
//       errors.contactNo = 'Contact Number is required';
//     } else if (!contactRegex.test(number)) {
//       errors.contactNo = 'Kindly enter correct number';
//     }

//     if (!agreeToTerms) {
//       errors.agreeToTerms = 'You must agree to the Terms & Conditions';
//     }

//     setErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   // Handle Change Function
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     const newErrors = { ...errors };

//     if (name === 'fullName') {
//       setName(value);
//       delete newErrors['fullName'];
//     } else if (name === 'email') {
//       setEmail(value);
//       delete newErrors['email'];
//     } else if (name === 'contactNo') {
//       setNumber(value);
//       delete newErrors['contactNo'];
//     }

//     setErrors(newErrors);
//   };

//   const handleCheckboxChange = (e) => {
//     setAgreeToTerms(e.target.checked);
//     const newErrors = { ...errors };
//     delete newErrors['agreeToTerms'];
//     setErrors(newErrors);
//   };
  

  
  
//   return (
//   <div>
//       <Headers />
//       <ToastContainer />
//       <div style={{backgroundColor:'#E6EDF3',height: '85vh', width: '100vw', margin: '0',padding: '0'}}>
//       <div className="container py-3" >
//         <div className="formBoxsh">
//           <div className="container">
//             <Row>
//               <Col xs={5} style={{ padding: '0px', flex: '0 0 auto', width: '41.66666667%' }} className="FormImages">
//                 <div style={{ textAlign: 'center', marginBottom: '10px' }}>
//                   <img alt='imageRac' src={Hero} style={{ width: '95%', borderRadius: '10px 10px 10px 10px', marginTop: '10px', height: '445px' }} />
//                 </div>
//               </Col>
//               <Col xs={12} md={7} style={{ padding: '0px', position: 'relative' }}>
//                 <div className='mainTopic'
//                   style={{
//                     width: '55%',
//                     height: '20%',
//                     borderRadius: '0px 10px 10px 0px',
//                     border: '7px solid #00A0E3',
//                     marginTop: '10px',
//                     fontWeight: '600',
//                     backgroundColor: '#00A0E3',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                   }}>
//                   <Zoom right>
//                     <h5  style={{ color: '#ffff', fontFamily: 'Lato, sans-serif', margin: '0px', fontWeight: '600' }}>One step to get quality leads</h5>
//                   </Zoom>
//                 </div>
//                 <Link to="/selectservices"><IoChevronBackCircleOutline className='backButton' size={40} style={{ position: 'absolute', right: '5%', top: '2%', color: 'red' }} /></Link>
                
//                   <div className="calenderHeight" style={{ marginTop: '25px', display: 'flex', justifyContent: 'center' }}>
//                     <div className="container">
//                       {/* Personal Details */}
//                       <Row>
//                         <Col xs={12} md={4}>
//                           <Form.Group>
//                             <Form.Label>Full Name</Form.Label>
//                             <Form.Control
//                               type="text"
//                               name="fullName"
//                               value={name}
//                               onChange={handleChange}
//                               isInvalid={!!errors.fullName} />
//                             <Form.Control.Feedback type="invalid">{errors.fullName}</Form.Control.Feedback>
//                           </Form.Group>
//                         </Col>
//                         <Col xs={12} md={4}>
//                           <Form.Label>Email</Form.Label>
//                           <Form.Control
//                             type="email"
//                             name="email"
//                             onChange={handleChange}
//                             isInvalid={!!errors.email}
//                           />
//                           <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
//                         </Col>
//                         <Col xs={12} md={4}>
//                           <Form.Label>Contact Number</Form.Label>
//                           <Form.Control
//                             type="type"
//                             name="contactNo"
//                             value={number}
//                             onChange={handleChange}
//                             isInvalid={!!errors.contactNo} />
//                           <Form.Control.Feedback type="invalid">{errors.contactNo}</Form.Control.Feedback>
//                         </Col>
//                       </Row>

//                       {/* Region area */}
//                     <Row className="mt-4">
//                     <Row className="mt-4">
//                         <Col xs={12} md={6}>
//                         <Select
//                               options={countryOptions}
//                               value={myCountry}
//                               onChange={(selectedOption) => {
//                                 setCountry(selectedOption);
//                                 setState([]); // Reset selected state(s)
//                                 fetchStates(selectedOption.value); // Fetch states for selected country
//                               }}
//                               placeholder="--Select country--"
//                             />
//                         </Col>

//                         {/* State Dropdown */}
//                         <Col xs={12} md={6}>
//                         <Select
//                           isMulti
//                           options={stateOptions} // Dynamic options (pass your fetched data here)
//                           value={state}
//                           onChange={setState}
//                           isDisabled={!myCountry}
//                           placeholder="--Select State--"
//                           closeMenuOnSelect={false}
//                           hideSelectedOptions={false}
//                           components={{
//                             Option: (props) => {
//                               const { data, isSelected, innerRef, innerProps } = props;
//                               return (
//                                 <div ref={innerRef} {...innerProps} style={{ display: "flex", alignItems: "center", padding: "5px" }}>
//                                   <input
//                                     type="checkbox"
//                                     checked={isSelected}
//                                     onChange={() => {}} // Required to prevent React warnings
//                                     style={{ marginRight: "8px" }}
//                                   />
//                                   {data.label}
//                                 </div>
//                               );
//                             },
//                           }}
//                         />

//                         </Col>
//                       </Row>
//                     </Row>

//                       {/* Area Name */}
//                       <Row className="mt-4">
//                         <Col xs={12} md={4}>
//                           <TextField  name="brandName" label="Brand Name" variant="outlined" style={{ width: '100%',  }} className='inputBoxes'  value={brand}  onChange={(e)=> setBrand(e.target.value)} />
//                         </Col>
//                         <Col xs={12} md={4}>
//                           <TextField name="websiteURL" label="Website url" variant="outlined" style={{ width: '100%',}} className='inputBoxes'  value={websiteURL}  onChange={(e)=> setWebsiteURL(e.target.value)}  />
//                         </Col>
//                       </Row>
//               <div className="d-flex align-items-center mt-4">
//                 <FormControlLabel
//                   control={<Checkbox color="primary" checked={agreeToTerms} onChange={handleCheckboxChange} />}
//                   label={
//                     <p style={{ fontSize: "14px", color: "#555", marginBottom:'0px' }}>
//                       I agree to the <span  onClick={() => setModalShow(true)} style={{ color: "#007bff", textDecoration: "none", fontWeight: "500" }}>Terms & Conditions</span>
//                     </p>
//                   }
//                 />
//                 {errors.agreeToTerms && <span style={{ color: 'red', marginLeft: '10px' }}>{errors.agreeToTerms}</span>}
//               </div>
        
//               <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '15px 0px 15px 0px' }}>
//                 <button className='button-47' onClick={handleSubmit} disabled={loading}>
//                   {loading ? (
//                     <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                   ) : (
//                     <>PROCESS</>
//                   )}
//                 </button>
//               </div>
//                     </div>
//                   </div> 
            
//               </Col>
//             </Row>
//           </div>
//         </div>
//       </div>
//       </div>
//       <Tcmodel show={modalShow} onHide={() => setModalShow(false)}/>
//     </div>
//   );
// };

// export default Finalform;



